import '../styles/application.css'
import App from '../components/App.svelte'
import { mount } from 'svelte'

const target = document.getElementById('app')

if (target) {
  const props = JSON.parse(target.dataset.props || '{}')
  mount(App, { target, props })
}
